import { createContext } from 'react';
import EditVenueContext from 'types/contexts/EditVenueContext';

export default createContext({} as EditVenueContext);
